document.addEventListener('DOMContentLoaded', function () {
  console.log('App loaded');
});

// Smooth scrolling for anchor links (except within #toc-list)
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
      // Skip smooth scrolling for links inside #toc-list
      if (this.closest('#toc-list')) {
        return;
      }

      const href = this.getAttribute('href');

      // Ignore links with just "#" or empty href
      if (href === '#' || href === '') {
        return;
      }

      const target = document.querySelector(href);

      if (target) {
        e.preventDefault();
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    });
  });
});

// Import interactive map functionality
import './interactive-map.js';

// Import MapLibre property maps
import './maplibre-map.js';

// Import mobile menu functionality
import './mobile-menu.js';

// Touch/tablet dropdown support for desktop nav
import './touch-dropdowns.js';

// Import sticky navigation functionality
import './table-of-contents.js';

// Import forms functionality
import './forms.js';
